<form [formGroup]="form" class="grid grid-cols-none lg:grid-cols-5 gap-4">

  <div class="lg:col-span-2 rounded-2xl bg-neutral-100 flex flex-col gap-5 p-6 h-fit">

    <div class="flex flex-col lg:flex-row gap-4">
      <h3 class="text-[1.25rem]">Apertura nuevo<br/> plan</h3>
      <div class="ml-auto mb-auto pt-2 w-fit">
        <div class="outline warning truncate !py-1 !px-2 cd-text-b4 flex flex-row gap-2">
          <div class="bg-yellow-300 rounded-full h-4 w-4 my-auto"></div>
          <span class="truncate">En espera</span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-3 w-full">
      <p>Vas a cerrar el plan actual y a lanzar el siguiente. Introduce los datos del nuevo plan.</p>
      <p class="cd-text-b4 text-neutral-500">Las tareas del plan actual no se migran automáticamente al plan sucesor.</p>

      <div class="form-control">
        <label class="text-neutral-900" for="name">Nombre del nuevo plan</label>
        <div class="input-icon">
          <input autocomplete="off" id="name" formControlName="name" placeholder="Por defecto: Plan (año siguiente)" type="text">
        </div>
      </div>

      <div class="form-control">
        <label class="text-neutral-900" for="endDate">Fecha de finalización del nuevo plan</label>
        <core-datepicker formControlName="endDate" class="!py-2" placeholder="31/12/2026"/>
      </div>

      <div class="form-control flex-1 w-full">
        <label class="text-neutral-900" for="description">Descripción</label>
        <textarea id="description" formControlName="description" placeholder="Descripción" rows="3"></textarea>
      </div>

      <div class="form-control flex-1 w-full">
        <label class="text-neutral-900" for="goals">Objetivos</label>
        <textarea id="goals" formControlName="goals" placeholder="Objetivos" rows="3"></textarea>
      </div>

      <div class="w-full flex flex-row items-center gap-4">
        <button (click)="submitPlan()" class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]" type="button"
                [disabled]="isSubmitting"
                style="border-radius: 0.5rem;padding: 0.5rem 1rem">
          <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/send.svg">
          <span class="hidden lg:block cd-text-md truncate">
            {{ isSubmitting ? 'Guardando...' : 'Lanzar el nuevo plan' }}
          </span>
        </button>

        <button class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]" type="button"
                [disabled]="isSubmitting"
                style="border-radius: 0.5rem;padding: 0.5rem 1rem">
          <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/x.svg">
          <span class="hidden lg:block cd-text-md truncate capitalize">Cancelar</span>
        </button>
      </div>

      @if (errorMessage) {
        <span class="cd-text-b4 text-error-600">{{ errorMessage }}</span>
      }
    </div>
  </div>

  <div class="lg:col-span-3 flex flex-col gap-5">
    <div class="rounded-2xl bg-neutral-100 p-6">
      <h3 class="mb-3 text-[1.25rem]">Resumen de cierre</h3>
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        <article class="bg-neutral shadow-e1 h-full p-3 flex flex-col gap-1 justify-center rounded-xl">
          <span class="cd-text-b4 text-neutral-500">Encuestas reenviadas</span>
          <h2>{{ phaseOneSurveyCount }}</h2>
        </article>
        <article class="bg-neutral shadow-e1 h-full p-3 flex flex-col gap-1 justify-center rounded-xl">
          <span class="cd-text-b4 text-neutral-500">Declaraciones modificadas</span>
          <h2>{{ phaseOneDeclarationCount }}</h2>
        </article>
        <article class="bg-neutral shadow-e1 h-full p-3 flex flex-col gap-1 justify-center rounded-xl">
          <span class="cd-text-b4 text-neutral-500">Controles heredados</span>
          <h2>{{ phaseThreeSummary.inherit }}</h2>
        </article>
        <article class="bg-neutral shadow-e1 h-full p-3 flex flex-col gap-1 justify-center rounded-xl">
          <span class="cd-text-b4 text-neutral-500">Controles promocionados</span>
          <h2>{{ phaseThreeSummary.promote }}</h2>
        </article>
        <article class="bg-neutral shadow-e1 h-full p-3 flex flex-col gap-1 justify-center rounded-xl">
          <span class="cd-text-b4 text-neutral-500">Controles finalizados</span>
          <h2>{{ phaseThreeSummary.finalize }}</h2>
        </article>
      </div>
    </div>

    <div class="rounded-2xl bg-neutral-100 p-6">
      <h3 class="mb-4 text-[1.25rem]">Encuestas reenviadas</h3>
      <core-table
        [data]="phaseOneSurveys"
        [headers]="[
          { label: 'Encuesta', field: 'name' },
          { label: 'Nº Preguntas', field: 'questionsCount', options: {align: 'center', verticalAlign: 'middle'}},
          { label: 'Empleados', field: 'employeesCount', options: {align: 'center', verticalAlign: 'middle'}},
          { label: 'Respondidas', field: 'completedCount', options: {align: 'center', verticalAlign: 'middle'}}
        ]"
      />
    </div>

    <div class="rounded-2xl bg-neutral-100 p-6">
      <h3 class="mb-4 text-[1.25rem]">Declaraciones modificadas</h3>
      <core-table
        [data]="phaseOneDeclarations"
        [headers]="[
          { label: 'Declaración', field: 'name' },
          { label: 'Variable', field: 'variableName', options: { verticalAlign: 'middle' }},
          { label: 'Valor', field: 'declaredValue', options: { verticalAlign: 'middle' }}
        ]"
      />
    </div>

    <div class="rounded-2xl bg-neutral-100 p-6">
      <h3 class="mb-4 text-[1.25rem]">Controles y resultado esperado</h3>
      <core-table
        [data]="phaseThreeControls"
        [headers]="[
          { label: 'Control', field: 'name' },
          { label: 'Decisión', customTemplate: decisionTmpl, options: { align: 'center', verticalAlign: 'middle'}},
          { label: 'Nuevo estado', customTemplate: outcomeTmpl, options: { verticalAlign: 'middle' }}
        ]"
      />
    </div>

  </div>
</form>

<ng-template #decisionTmpl let-item>
  <span class="outline primary !py-0 !px-2 cd-text-b5">{{ controlDecisionLabel(item) }}</span>
</ng-template>

<ng-template #outcomeTmpl let-item>
  <span class="cd-text-b4 text-neutral-700">{{ controlOutcomeLabel(item) }}</span>
</ng-template>
